import "devextreme/dist/css/dx.light.css";

import { arClient } from "@/api/ar-client";
import SearchList from "../ultils/SearchList/SearchList.vue";
import SidebarSection from "../ultils/Sidebar/SidebarSection.vue";
import ModalClient from "./ModalClient/ModalClient.vue";
import SidebarClient from "./SidebarClient/SidebarClient.vue";
import ModalUserVue from "../User/components/ModalUser.vue";
import FormItems from "../ultils/Form/FormItems.vue";
import TableAccount from "../ListAccount/components/TableAccount.vue";
import SectionTransformTable from "../ultils/Section/SectionTransformTable.vue";

import "@core/scss/vue/libs/vue-select.scss";

import EzTable from "../ultils/Table/EzTable.vue";
import SidebarTransaction from "./SidebarTransaction/SidebarTransaction.vue";
import PermissionButton from "../ultils/Button/PermissionButton.vue";
import { useFetch } from "../ultils/Hooks/useFetch.ts";
import { defineComponent, getCurrentInstance, ref } from "@vue/composition-api";
import {
  convertCommonActiveStatus,
  convertTravelAgentIsOverDraftStatus,
} from "../ultils/status.js";
import { AR_RAA01, AR_RCL02,AR_ICL01 } from "@/api/constant.js";

export default defineComponent({
  name: "RateCode",
  components: {
    PermissionButton,
    ModalUserVue,
    SidebarSection,
    ModalClient,
    SidebarClient,

    EzTable,
    SectionTransformTable,

    FormItems,

    TableAccount,

    SearchList,

    SidebarTransaction,
  },
  setup() {
    const tableRef = ref();
    const vm = getCurrentInstance().proxy;
    const searchVal = ref({});
    const isShowModal = ref(false);
    const formItems = ref([
      {
        type: "string",
        name: "SearchKey",
        placeholder: "ar_client_code_name_taxcode_vv",
        label: "ar_client_company",
        wrapperClass: "col-3",
      },
      {
        type: "select",
        dataSource: [
          { Id: 1, Label: vm.$t("ar_client_active") },
          { Id: 0, Label: vm.$t("ar_client_in_active") },
        ],

        name: "Status",
        labelOption: "Label",
        label: "ar_client_status",
        wrapperClass: "col-3",
      },
    ]);
    const isShowSidebar = ref();

    const columns = ref([
      {
        caption: "ar_common_company_code",
        field: "TravelAgentCode",
        minWidth: "130px",
      },
      {
        caption: "ar_common_company_name",
        field: "NameVi",
        minWidth: "13%",
      },
      /*  {
          caption: "ar_client_type",
          field: "TravelAgentType",
        }, */
      {
        caption: "ar_common_tax_code",
        field: "TaxCode",
        minWidth: "100px",
      },
      {
        caption: "ar_common_phone",
        field: "Tel1",
        minWidth: "130px",
      },
      {
        caption: "ar_common_address",
        field: "Address1",
        minWidth: "12%",
      },
      {
        caption: "ar_client_district",
        field: "StateVi",
        minWidth: "13%",
        visible: false,
      },
      {
        caption: "ar_common_city",
        minWidth: "10%",
        field: "CityVi",
      },
      {
        caption: "ar_common_country",
        field: "Address2",
        minWidth: "10%",
        visible: false,
      },
      {
        caption: "ar_client_total_money",
        field: "AccountsDebitBalance",
        minWidth: "120px",
        cellTemplate: true,
        formatType: "currency",
      },
      {
        caption: "ar_client_over_draft_status",
        field: "IsOverDraft",
        minWidth: "120px",
        cellTemplate: true,
        formatType: "text-variant",
        renderTextVariant: convertTravelAgentIsOverDraftStatus,
      },
      {
        caption: "ar_client_status",
        field: "InActive",
        minWidth: "120px",
        cellTemplate: true,
        formatType: "text-variant",
        renderTextVariant: convertCommonActiveStatus,
      },
      {
        caption: "ar_client_created_date",
        field: "CreatedDate",
        minWidth: "130px",
        cellTemplate: true,
        formatType: "date",
      },
    ]);
    const actions = ref([
      {
        apiCode: AR_RCL02,
        title: "ar_common_detail",
        icon: "eye",
      },

      {
        apiCode: AR_RAA01,
        icon: "list",
        title: "ar_client_list_account",
      },
    ]);

    const refetchData = () => {
      tableRef.value.fetchData();
    };
    const { fetchData: fetchDetailTravelAgent, data: detailTravelAgentData } = useFetch(
      arClient.api_AR_RCL02,
      {
        nextFunction: () => {
          isShowSidebar.value = true;
        },
      }
    );
    return {
      AR_ICL01,
      isShowModal,
      columns,
      formItems,
      searchVal,
      tableRef,
      refetchData,
      fetchDetailTravelAgent,
      actions,
      isShowSidebar,
      detailTravelAgentData,
    };
  },
});
